<template>
  <div>
    <Navbar ref="navbarRef" :selectedOption="1" />
    <h4></h4>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td><label for="nombre" class="form-label">Nombre</label></td>
          <td>
            <input
              type="text"
              class="form-control"
              id="nombreBusqueda"
              name="nombreBusqueda"
              v-model="nombreBusqueda"
              style="width: 500px; text-transform: uppercase"
              required
            />
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPagina(1)"
              title="Buscar registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >search</i
              >
              Buscar
            </button>
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPaginaTodos(1)"
              title="Todos los registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >auto_awesome_motion</i
              >
            </button>
          </td>
          <td>
            <button
              type="submit"
              class="btn btn-light"
              data-bs-toggle="modal"
              data-bs-target="#ventanaModal"
              @click="abrirModalCrear"
              title="Nuevo registro"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: green; cursor: pointer"
                >add_box</i
              >
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Numero</th>
          <th scope="col">Cedula</th>
          <th scope="col">Fecha desde</th>
          <th scope="col">Fecha hasta</th>
          <th scope="col">Diag1</th>
          <th scope="col">Diag2</th>
          <th scope="col">Valor</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="cargaext in datosPaginados" :key="cargaext.idcargaFinan">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(cargaext.idcargaFinan)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirEditar(cargaext.idcargaFinan)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ cargaext.numero }}</td>
          <td>{{ cargaext.cedula }}</td>
          <td>{{ getFormattedDate(cargaext.fechaDesde, "DD/MM/YYYY") }}</td>
          <td>{{ getFormattedDate(cargaext.fechaHasta, "DD/MM/YYYY") }}</td>
          <td>{{ cargaext.diag1 }}</td>
          <td>{{ cargaext.diag2 }}</td>
          <td>{{ cargaext.valor }}</td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deletecargaFinan(cargaext.idcargaFinan)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idcargaFinan" class="form-label"
                      >IdcargaFinan</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idcargaFinan"
                      name="idcargaFinan"
                      v-model="datocargaFinan.idcargaFinan"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Tramite -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idTramite" class="form-label"> Tramite</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idTramite"
                      name="idTramite"
                      v-model="datocargaFinan.idTramite"
                    >
                      <option
                        v-for="tramite in tramites"
                        :value="tramite.idTramite"
                        :key="tramite.idTramite"
                      >
                        {{ tramite.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Tramite -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="numero" class="form-label">Numero</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="numero"
                      name="numero"
                      v-model="datocargaFinan.numero"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="cedula" class="form-label">Cedula</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="cedula"
                      name="cedula"
                      v-model="datocargaFinan.cedula"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaDesde" class="form-label"
                      >FechaDesde</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      id="fechaDesde"
                      name="fechaDesde"
                      v-model="datocargaFinan.fechaDesde"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaHasta" class="form-label"
                      >FechaHasta</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      id="fechaHasta"
                      name="fechaHasta"
                      v-model="datocargaFinan.fechaHasta"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="diag1" class="form-label">Diag1</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="diag1"
                      name="diag1"
                      v-model="datocargaFinan.diag1"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="diag2" class="form-label">Diag2</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="diag2"
                      name="diag2"
                      v-model="datocargaFinan.diag2"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="valor" class="form-label">Valor</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="valor"
                      name="valor"
                      v-model="datocargaFinan.valor"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <div class="me-auto">
              <button
                type="button"
                id="send"
                class="btn btn-light"
                data-bs-dismiss="modal"
                title="Cerrar"
              >
                <i
                  class="material-icons"
                  style="font-size: 32px; color: orangered; cursor: pointer"
                  >meeting_room</i
                >
              </button>
            </div>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarcargaFinan"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarEditcargaFinan"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import config from '@/config';
import Navbar from "../../components/Navbar.vue";
import Footer from "../../components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "../../modules/dateFormat.js";
import { format } from "date-fns";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      cargaexts: [],
      datocargaFinan: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      tramites: [],
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  computed: {
    formattedFechaReg() {
      const originalDate = new Date(this.datoAuto.fechaReg);
      return format(originalDate, "dd/MM/yyyy");
    },
  },

  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
    this.$refs.navbarRef.toggleProcesos();
    this.$refs.navbarRef.toggleReportes();
    this.$refs.navbarRef.toggleParametros();
    this.$refs.navbarRef.toggleAyuda();
    this.fetchTramites();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.cargaexts.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwcargaexts/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.cargaexts = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.cargaexts.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwcargaexts").then((response) => {
        this.cargaexts = response.data.reverse();
        this.paginaActual = noPagina;
        this.datosPaginados = [];
        let ini = noPagina * this.elementosPorPagina - this.elementosPorPagina;
        let fin = noPagina * this.elementosPorPagina;
        this.datosPaginados = this.cargaexts.slice(ini, fin);
      });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = [
        "idTramite",
        "numero",
        "cedula",
        "fechaDesde",
        "fechaHasta",
        "diag1",
        "diag2",
        "valor",
      ];
      const requiredFieldsText = [
        "idTramite",
        "numero",
        "cedula",
        "fechaDesde",
        "fechaHasta",
        "diag1",
        "diag2",
        "valor",
      ];
      return validarForm(
        this.datocargaFinan,
        requiredFields,
        requiredFieldsText
      );
    },
    async guardarcargaFinan() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/cargaexts",
            this.datocargaFinan
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "cargaFinan creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditcargaFinan() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/cargaexts",
            this.datocargaFinan
          );
          $("#ventanaModal").modal("hide");
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "cargaFinan creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datocargaFinan = {};
      this.titulo = "Crear ";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idcargaFinan) {
      this.modalWindow = true;
      if (idcargaFinan != null) {
        api.get("/vwcargaexts/" + idcargaFinan)
          .then((resp) => {
            this.datocargaFinan = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar ";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idcargaFinan) {
      if (idcargaFinan != null) {
        this.$router.push("/cargaextmd/" + idcargaFinan);
      }
    },
    async deletecargaFinan(idcargaFinan) {
      try {
        await api.delete("/cargaexts/" + idcargaFinan
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    fetchTramites() {
      fetch(config.apiBaseUrl + "/tramites")
        .then((response) => response.json())
        .then((data) => {
          this.tramites = data;
        })
        .catch((error) => {
          console.error("Error fetching tramites:", error);
        });
    },
  },
};
</script>
